var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"no-gutters",staticStyle:{"position":"relative"}},[_c('Map',{staticClass:"pa-0"}),_c('Contacts')],1)}
var staticRenderFns = []

export { render, staticRenderFns }